import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import {
  faHotel, faBus, faPassport, faTicketAlt, faHandsHelping, faCalendar,
  faClock, faPlaneArrival, faPlaneDeparture, faLocationDot, faLocationArrow,
  faMountainCity, faGift, faKaaba
} from '@fortawesome/free-solid-svg-icons';
import { PackageView } from './umra-offers.component';

/**
 * One package card, extracted so it can run with OnPush:
 */
@Component({
  selector: 'app-package-card',
  templateUrl: './package-card.component.html',
  styleUrls: ['./umra-offers.component.css'],   // reuse existing styles – nothing to move
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageCardComponent {
  @Input() offer: PackageView;
  @Output() gallery = new EventEmitter<{ name: string; type: string }>();

  faHotel = faHotel; faBus = faBus; faPassport = faPassport;
  faTicketAlt = faTicketAlt; faHandsHelping = faHandsHelping; faCalendar = faCalendar;
  faClock = faClock; faPlaneArrival = faPlaneArrival; faPlaneDeparture = faPlaneDeparture;
  faLocationDot = faLocationDot; faLocationArrow = faLocationArrow;
  faMountainCity = faMountainCity; faGift = faGift; faKaaba = faKaaba;

  openGallery(hotelName: string, hotelType: string): void {
    this.gallery.emit({ name: hotelName, type: hotelType });
  }

  onLogoError(event: Event): void {
    const img = event.target as HTMLImageElement;
    const fallback = img.dataset.fallback;
    if (fallback && !img.dataset.tried) {
      img.dataset.tried = '1';
      img.src = fallback;
      return;
    }
    img.style.display = 'none';
    const icon = img.nextElementSibling as HTMLElement;
    if (icon) { icon.style.display = 'block'; }
  }

  formatPrice(price: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(price);
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric', month: 'short', day: 'numeric'
    });
  }

  getTooltipContent(offer: PackageView, type: number): string {
    let baseAmount: number;
    if (type === 1) { baseAmount = offer.priceSharing; }
    else if (type === 2) { baseAmount = offer.priceQuad; }
    else if (type === 3) { baseAmount = offer.priceTriple; }
    else { baseAmount = offer.priceDouble; }
    const finalAmount = baseAmount - offer.discountOnSupplier;

    return [
      `Package: ${offer.packageCode} (${offer.customPackageId})`,
      `───────────────────`,
      `Basic ---------- ${this.formatPrice(baseAmount)}`,
      `Discount ---------- ${this.formatPrice(offer.discountOnSupplier)}`,
      `Payable Amount -- ${this.formatPrice(finalAmount)}`
    ].join('\n');
  }
}
